import React, { ReactNode } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

const EducationInfoContext = React.createContext<{
    value: null;
    set: (v: any) => void;
} | undefined>(undefined);

export const EducationInfoProvider = ({ children }: { children: ReactNode }) => {
    const [v, setV] = React.useState(null);

    return (
        <EducationInfoContext.Provider
            value={{
                value: v,
                set(v) {},
            }}
        >
            {children}
        </EducationInfoContext.Provider>
    );
};

export const useEducationInfo = () => {
    const ctx = React.useContext(EducationInfoContext);
    if (!ctx) {
        throw new Error('useEducationInfo must be used inside EducationInfoProvider');
    }
    return ctx;
};
